import { useToast } from '@contexts/Toast';
import { useEffect, useState, useCallback } from 'react';
import { Axios } from '../Helpers/ApiService';
import { errorMessage } from '../Helpers/Constants';
import { ApiEndpoints } from '../Helpers/Constants/Navigation';
import { State } from '../Helpers/Models';

export function useFetchStateName() {
  const [states, setStates] = useState<State[]>([]);
  const { showToastMessage } = useToast();

  // Fetch states from API
  useEffect(() => {
    const fetchStates = async () => {
      try {
        const response = await Axios.get(ApiEndpoints.FETCH_STATES);
        setStates(response.data.data);
      } catch (error) {
        showToastMessage(errorMessage.FETCH_ERROR, 'error');
      }
    };

    fetchStates();
  }, []);

  // Memoized function to get state name by ID
  const getStateName = useCallback(
    (id: number) => {
      const state = states.find((s) => s.id === id);
      return state ? state.stateName : '';
    },
    [states],
  );

  return { states, getStateName };
}
